<template>
  <header>
    <div class="banner-container">
      <router-link to="/" class="logo">
        <banner-logo />
      </router-link>
      <div v-if="showLogin" class="login">
        <router-link id="signin" v-t to="/signin">Sign In</router-link>
        <router-link id="signup" v-if="allowSignup" v-t class="button" to="/signup">Create Account</router-link>
      </div>
    </div>
  </header>
</template>

<script>

import getBrandConfig from '@/lib/utils/get_brand_config';
import BannerLogo from './banner_logo';

const brandConfig = getBrandConfig();

export default {
  components: {
    BannerLogo,
  },
  props: {
    transparent: {
      type: Boolean,
      default: false,
    },
    lightStyle: {
      type: Boolean,
      default: false,
    },
    showLogin: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    allowSignup: () => brandConfig.allowSignup,
  },
};
</script>

<style lang="scss" scoped>
  header {
    background-color: $white;
  }

  .logo {
    text-decoration: none;
  }

  .banner-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0.5rem 0.75rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 3rem;
    min-height: 3rem;
    width: 100%;
  }

  .login {
    flex: 1 0 auto;
    text-align: right;

    #signin {
      padding: 0.75rem;
      text-decoration: none;
    }
  }
</style>
